const Courses = () => import('~/pages/courses').then(m => m.default || m)
const Course = () => import('~/pages/course').then(m => m.default || m)
const Teacher = () => import('~/pages/teacher').then(m => m.default || m)

const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

export default [
  { path: '/', name: 'courses', component: Courses },
  { path: '/course/:term-:course/:title', name: 'course', component: Course },
  { path: '/directory/:uid', name: 'teacher', component: Teacher },

  { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// /resources/js/router/routes.js